import { RESET_FORM } from '../actionTypes';
import { createProposalModalActions } from '../reducer';

export default () => createProposalModalActions[RESET_FORM]();
